<script lang="ts" setup>
import ModalComponent from '@/components/ModalComponent.vue'
import { SchemeResponse } from '@/services/models/SchemeResponse.ts'

defineProps<{
  scheme: SchemeResponse
}>()

defineEmits(['closeClicked'])
</script>

<template>
  <ModalComponent
    :has-controls="false"
    :is-closable="true"
    @cancel="$emit('closeClicked')"
    @close="$emit('closeClicked')"
  >
    <template #title>
      <h2 class="modal__subtitle">
        Scheme debug info
      </h2>

      <p>{{ scheme.fileName }}</p>

      <div class="modal__update-description span">
        Total score: {{ scheme.score.totalScore }} of {{ scheme.score.maxScore }} ({{ scheme.score.totalScorePercent }} %)
      </div>
    </template>

    <template #text>
      <div class="scheme-debug-info">
        <ul>
          <li v-for="rule in scheme.score.ruleScores" :key="rule.ruleName">
            {{ rule.ruleName }} ({{ rule.score }} of {{ rule.maxScore }})

            <ul>
              <li v-for="(reason, ri) in rule.reasons" :key="ri">
                {{ reason }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </template>
  </ModalComponent>
</template>

<style lang="scss" scoped>
.scheme-debug-info {
  text-align: left;
  margin-left: 1rem;

  ul {
    list-style-type: square;

    li {
      padding: 0.125rem 0;
      line-height: 1.3;
    }
  }

  ul ul {
    padding-left: 2rem;
    list-style-type: circle;

    li {
      line-height: 1.4;
    }
  }
}
</style>
